import type { SVGProps } from "react";

export interface SvgProps extends SVGProps<SVGSVGElement> {}

export const Svg = ({ children, ...rest }: SvgProps) => {
	return <svg {...rest}>{children}</svg>;
};
